/* eslint-disable no-console */
import { AppDispatch } from 'src/app/store'
import { Offer, RequestForProposalPayload } from 'src/core/models'
import * as api from './api'
import * as reducers from './slice-reducers'

export const getUserOffers = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setOffersListLoading(true))
    const data: Offer[] = await api.getOffersAPI()
    dispatch(reducers.setOffersListLoading(false))
    dispatch(reducers.setOffersList(data))
  } catch (error) {
    dispatch(reducers.setOffersListLoading(false))
  }
}

export const expireOffer = (id: number) => async () => {
  try {
    await api.expireOfferAPI(id)
  } catch (error) {
    console.log('Error on Expire Offer', id, error)
  }
}

export const declineOffer = (id: number, newState: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setOffersDeclineLoading(true))
    await api.declineOfferAPI(id)
    dispatch(reducers.setOffersDeclineLoading(false))
    dispatch(reducers.setOffersDeclineSuccess(true))
    dispatch(reducers.updateOfferState({ id, newState }))
  } catch (error) {
    console.log('Error on Decline Offer', id, error)
    dispatch(reducers.setOffersDeclineLoading(false))
    dispatch(reducers.setOffersDeclineSuccess(false))
  }
}

export const acceptOffer = (id: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setOffersAcceptLoading(true))
    const data = await api.acceptOfferAPI(id)
    dispatch(reducers.setOffersAcceptLoading(false))
    dispatch(reducers.setOffersAcceptSuccess(true))
    const newState = data === 'SUCCESS' ? 'accepted' : 'cancelled'
    dispatch(reducers.updateOfferState({ id, newState }))
  } catch (error) {
    console.log('Error on Accept Offer', id, error)
    dispatch(reducers.setOffersAcceptLoading(false))
    dispatch(reducers.setOffersAcceptSuccess(false))
  }
}

export const sendRequestForProposal = (payload: RequestForProposalPayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setRequestForProposalLoading(true))
    await api.sendRequestForProposalAPI(payload)
    dispatch(reducers.setRequestForProposalLoading(false))
    dispatch(reducers.setRequestForProposalSuccess(true))
  } catch (error) {
    dispatch(reducers.setRequestForProposalLoading(false))
    dispatch(reducers.setRequestForProposalSuccess(false))
  }
}
